export var RouterActionTypes;
(function (RouterActionTypes) {
    RouterActionTypes["ADD_ROUTE_CONFIGURATION"] = "ADD_ROUTE_CONFIGURATION";
    RouterActionTypes["SYNC_ROUTE"] = "SYNC_ROUTE";
    RouterActionTypes["NAVIGATE_TO_STATE"] = "NAVIGATE_TO_STATE";
    RouterActionTypes["NAVIGATE_TO_URL"] = "NAVIGATE_TO_URL";
    RouterActionTypes["GO_BACK"] = "GO_BACK";
    RouterActionTypes["UPDATE_ROUTE_CONFIGURATION"] = "UPDATE_ROUTE_CONFIGURATION";
})(RouterActionTypes || (RouterActionTypes = {}));
//# sourceMappingURL=router.action.types.js.map